<script lang="ts">
  import Container from "../components/Container.svelte";
</script>

<Container title={"制作物のページ"} color={"bg-teal-200"} linkTo={""} description={""}/>

<div class="mx-auto w-5/6">
  <h3>準備中</h3>
</div>
